export default __webpack_public_path__ + "static/media/ic-detail.00650fef.svg";